/**
 * @title Initialise Tracking Scripts
 * @description Logic for handling SEOMatic Tracking Scripts with Blitz
 */
export function initialiseTrackingScripts() {
	const cookie = doesCookieExist("cookies-accepted");

	if (cookie && cookie === true) {
		fetch(
			"/actions/seomatic/meta-container/meta-script-container/?uri=/&siteId=1",
			{
				method: "get",
			},
		)
			.then((response) => response.json())
			.then((response) => {
				let data = response.MetaScriptContainer;
				if (data) {
					data = JSON.parse(data);
					const headScripts = document
						.createRange()
						.createContextualFragment(data.script);
					const bodyScripts = document
						.createRange()
						.createContextualFragment(data.bodyScript);

					document.head.appendChild(headScripts);
					document.body.prepend(bodyScripts);
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}
}

/**
 * @title Does Cookie Exist?
 * @description Checks whether or not a given cookie exists.
 * @param {string} cookieName - The name of the cookie
 */
function doesCookieExist(cookieName) {
	if (document.cookie.split("; ").find((row) => row.startsWith(cookieName)))
		return true;

	return false;
}
